import { render, staticRenderFns } from "./CollectionMaterialLibrary.vue?vue&type=template&id=23f71bf4&scoped=true"
import script from "./CollectionMaterialLibrary.vue?vue&type=script&lang=js"
export * from "./CollectionMaterialLibrary.vue?vue&type=script&lang=js"
import style0 from "./CollectionMaterialLibrary.vue?vue&type=style&index=0&id=23f71bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f71bf4",
  null
  
)

export default component.exports